import { ELianlianCardStatus, ILianlianCard } from '../../types/lianlian';
import { computed, Ref } from 'vue';

export function useLianlianAccountStatus(info: Ref<ILianlianCard>) {
  const accountStatus = computed(() => info.value?.accountStatus);
  // const signStatus = computed(() => info.value?.todollcdSignStatus);

  const underConfirm = computed(() => accountStatus.value === ELianlianCardStatus.ACTIVATE_PENDING_NEW);
  const unapplyed = computed(() => accountStatus.value === ELianlianCardStatus.ACTIVATE_PENDING || !accountStatus.value);
  const approvaling = computed(() => [ELianlianCardStatus.CHECK_PENDING].includes(accountStatus.value));
  const approvalSuccess = computed(() => [ELianlianCardStatus.REMITTANCE_VALID_PENDING, ELianlianCardStatus.NORMAL].includes(accountStatus.value));
  const approvalFailed = computed(() => accountStatus.value === ELianlianCardStatus.CHECK_REJECT);
  const canceled = computed(() => accountStatus.value === ELianlianCardStatus.CANCEL);

  // const needPasswordFreeAuth = computed(() => accountStatus.value === ELianlianCardStatus.NORMAL && signStatus.value === ELianlianPayAuthStatus.Pending);
  // const passwordFreeAuthed = computed(() => approvalSuccess.value && signStatus.value === ELianlianPayAuthStatus.Enabled);
  // const passwordFreeAuthOutDate = computed(() => approvalSuccess.value && signStatus.value === ELianlianPayAuthStatus.Disabled);

  const statusTitle = computed(() => {
    if (approvalFailed.value) return '审核失败';

    if (approvaling.value) return '待审核';

    return '';
  });

  const statusSubTitle = computed(() => {
    if (unapplyed.value) return '暂未开通-连连账户';

    if (approvaling.value) return '连连账户开通审核中...';

    // @ts-ignore
    if (approvalFailed.value) return `失败原因：${info.value.remark || info.value?.lianBank?.remark || ''}`;

    return '';
  });

  return {
    /** 主状态 */
    statusTitle,
    /** 副状态 */
    statusSubTitle,
    /** 账号状态 */
    accountStatus,
    /** 待意愿确认 */
    underConfirm,
    /** 未开通 */
    unapplyed,
    /** 待审核 */
    approvaling,
    /** 已开户（正常） */
    approvalSuccess,
    /** 审核失败 */
    approvalFailed,
    /** 已销户 */
    canceled,
    // /** 暂未免费授权 */
    // needPasswordFreeAuth,
    // /** 免密授权成功 */
    // passwordFreeAuthed,
    // /** 免密授权过期 */
    // passwordFreeAuthOutDate,
  };
}
